export default "/static/tabbar/scan.png"